import React from "react";
import { useTranslation } from "react-i18next";
import { usePreferences } from "../context/PreferencesContext";

// A discreet privacy note. Preferences are only remembered with explicit consent.
export const ConsentBanner = () => {
  const { t } = useTranslation();
  const { consent, bannerOpen, grantConsent, declineConsent } = usePreferences();

  // Show only when undecided (first visit) or when reopened from Privacy Preferences.
  if (consent !== null && !bannerOpen) return null;

  return (
    <div
      data-testid="consent-banner"
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md z-[60] bg-primary-custom border border-subtle-custom shadow-2xl p-6 animate-fade-in"
    >
      <div className="space-y-4">
        <span className="text-[10px] font-sans tracking-[0.3em] uppercase text-[var(--accent-bronze)] font-semibold block">
          {t("consent.title")}
        </span>
        <p className="font-serif text-sm text-secondary-custom leading-relaxed font-light">
          {t("consent.body")}
        </p>
        <div className="flex items-center gap-3 pt-1">
          <button
            onClick={grantConsent}
            data-testid="consent-accept"
            className="flex-1 border border-[var(--accent-bronze)] bg-[var(--accent-bronze)] text-white py-2.5 text-[10px] font-sans tracking-[0.25em] uppercase hover:opacity-90 transition-all duration-300"
          >
            {t("consent.accept")}
          </button>
          <button
            onClick={() => { declineConsent(); }}
            data-testid="consent-decline"
            className="flex-1 border border-subtle-custom bg-surface-custom text-secondary-custom py-2.5 text-[10px] font-sans tracking-[0.25em] uppercase hover:text-primary-custom transition-all duration-300"
          >
            {t("consent.decline")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
